export default __webpack_public_path__ + "static/media/OSPUNCPBA.187df5d7.svg";